import { UseFormRegister, get } from 'react-hook-form';

/**
 * テキストフィールド基本コンポーネント
 */
export default function FormText(props: {
  // タイトル
  subject?: string;
  // name属性
  name: string;
  // プレースホルダー
  placeholder?: string;
  // 必須検証の有無
  required?: boolean;
  // 最大文字数
  maxLength?: number;
  // 最小文字数
  minLength?: number;
  // フォーマット
  format?: 'alphanumeric' | 'numeric' | 'email' | 'url' | 'tel';
  // inputタイプ
  type?: 'text' | 'password' | 'date';
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 読み取り専用
  readOnly?: boolean;
  // エラー情報
  errors: any;
  // クラス名
  className?: string;

  register: UseFormRegister<any>;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  // 検証タイプの取得
  const type = get(props.errors, props.name)?.type ?? null;
  // フォーマットの定義
  let pattern = undefined;
  switch (props.format) {
    // 英数字形式
    case 'alphanumeric':
      pattern = /^[a-zA-Z0-9]*$/i;
      break;
    // 数字形式
    case 'numeric':
      pattern = /^[0-9]*$/i;
      break;
    // メールアドレス形式
    case 'email':
      pattern = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*.)+[a-zA-Z]{2,}$/i;
      break;
    // URL形式
    case 'url':
      pattern = /^(http|https):\/\/([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}(\/\S*)?$/i;
      break;
    // 電話番号形式
    case 'tel':
      pattern = /\d{2,4}-\d{2,4}-\d{4}/;
      break;
    default:
      break;
  }

  return (
    <>
      {props.subject && (
        <label className="form-label">
          {props.subject}
          {props.requiredMark && (
            <span className={props.required ? 'must' : 'any'}>{props.required ? ' *' : ''}</span>
          )}
        </label>
      )}

      <input
        className={
          get(props.errors, props.name)
            ? `is-invalid form-control ${props.className}`
            : `form-control ${props.className}`
        }
        {...{ name: props.name }}
        readOnly={props.readOnly ? true : false}
        placeholder={props.placeholder}
        type={props.type ?? 'text'}
        {...props.register(props.name, {
          required: props.required,
          maxLength: props.maxLength,
          minLength: props.minLength,
          pattern: pattern,
        })}
        inputMode={props.format === 'numeric' ? 'tel' : undefined}
      />
      {/* {get(props.errors, props.name) && ( */}
      {/* {props.errors[props.name] && ( */}
      {get(props.errors, props.name) && (
        <p className="error">
          {type === 'required' && <>必須項目です。</>}
          {type === 'maxLength' && props.maxLength != props.minLength && (
            <>{props.maxLength}文字以内で入力してください。</>
          )}
          {type === 'minLength' && props.maxLength != props.minLength && (
            <>{props.minLength}文字以上で入力してください。</>
          )}
          {(type === 'maxLength' || type === 'minLength') &&
            props.maxLength === props.minLength && <>{props.minLength}文字で入力してください。</>}
          {type === 'pattern' && (
            <>
              {props.format === 'alphanumeric' && <>半角英数で入力してください。</>}
              {props.format === 'numeric' && <>半角数字で入力してください。</>}
              {props.format === 'email' && <>メールアドレス形式で入力してください。</>}
              {props.format === 'url' && <>URL形式で入力してください。</>}
              {props.format === 'tel' && <>半角数値とハイフンで入力してください。</>}
            </>
          )}
          {get(props.errors, props.name)?.type === 'custom' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
        </p>
      )}
    </>
  );
}
